export default "__VITE_ASSET__BkZT_isU__"